import typeA from "../image/gensphere/floorplan-type-a.jpg";
import typeB from "../image/gensphere/floorplan-type-b.jpg";
import typeC from "../image/gensphere/floorplan-type-c.jpg";
import typeD from "../image/gensphere/floorplan-type-d.jpg";
import typeE from "../image/gensphere/floorplan-type-e.jpg";

export const genSphereUnitLayouts = [
    {
        id: 1,
        unitType: "Type A",
        description:
            "459 sqft • 1 Bedroom • 2 Bathrooms •\nLiving Room • Kitchen • Balcony",
        image: typeA,
    },
    {
        id: 2,
        unitType: "Type B",
        description:
            "551 sqft • 1 + 1 Bedrooms • 2 Bathrooms •\nLiving Room • Kitchen",
        image: typeB,
    },
    {
        id: 3,
        unitType: "Type C",
        description: "652 sqft • 3 Bedrooms • 2 Bathrooms •\nLiving Room • Kitchen",
        image: typeC,
    },
    {
        id: 4,
        unitType: "Type D",
        description:
            "755 sqft • 3 Bedrooms • 2 Bathrooms •\nLiving Room • Kitchen • Balcony",
        image: typeD,
    },
    {
        id: 5,
        unitType: "Type E",
        description:
            "700 sqft • 1 Bedroom (Loft Unit) • 2 Bathrooms •\nLiving Room • Kitchen",
        image: typeE,
    },
]